import React, { CSSProperties } from 'react';

const PaymentsIcon = ({ className, style }: { className?: string | undefined; style?: CSSProperties | undefined }) => {
  return (
    <svg style={style} className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18px" height="18px">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 14V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zm-9-1c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-6v11c0 1.1-.9 2-2 2H4v-2h17V7h2z" />
    </svg>
  );
};

export default PaymentsIcon;
